// extracted by mini-css-extract-plugin
module.exports = {"submenu":"style_submenu__SgvT8","submenuItem":"style_submenu-item__IOkdc"};